import { SelfElectedStateFundingProgramInput } from "@outschool/gql-backend-generated";

export function shouldRequireMembershipForEnrollmentBasedOnSelfElectedStateFundingProgram(
  selfElectedStateFundingProgram:
    | SelfElectedStateFundingProgramInput
    | null
    | undefined,
): boolean {
  return (
    !selfElectedStateFundingProgram?.fundingOptions ||
    [
      // used in v1
      selfElectedStateFundingProgram?.fundingOptions?.charter,
      selfElectedStateFundingProgram?.fundingOptions?.statePortal,
      selfElectedStateFundingProgram?.fundingOptions?.reimbursement,
      // used in v2
      selfElectedStateFundingProgram?.fundingOptions?.otherProgramName,
      selfElectedStateFundingProgram?.fundingOptions?.stateDebitCard,
      selfElectedStateFundingProgram?.fundingOptions?.stateProgramName,
    ].every(option => !Boolean(option))
  );
}

export const userUsesSelfElectedPublicFundingOptions = (
  selfElectedStateFundingProgram:
    | SelfElectedStateFundingProgramInput
    | null
    | undefined,
): boolean => {
  return (
    !!selfElectedStateFundingProgram?.fundingOptions &&
    [
      // used in v1
      selfElectedStateFundingProgram?.fundingOptions?.charter,
      selfElectedStateFundingProgram?.fundingOptions?.statePortal,
      selfElectedStateFundingProgram?.fundingOptions?.reimbursement,
      // used in v2
      selfElectedStateFundingProgram?.fundingOptions?.stateDebitCard,
      selfElectedStateFundingProgram?.fundingOptions?.otherProgramName,
      selfElectedStateFundingProgram?.fundingOptions?.stateProgramName,
    ].some(option => Boolean(option))
  );
};

export function wasFundingProgramSelected(
  selfElectedStateFundingProgram:
    | SelfElectedStateFundingProgramInput
    | null
    | undefined,
): boolean {
  if (
    selfElectedStateFundingProgram?.fundingOptions &&
    [
      // used in v1
      selfElectedStateFundingProgram?.fundingOptions?.charter,
      selfElectedStateFundingProgram?.fundingOptions?.statePortal,
      selfElectedStateFundingProgram?.fundingOptions?.reimbursement,
      selfElectedStateFundingProgram?.fundingOptions?.selfPay,
      // used in v2
      selfElectedStateFundingProgram?.fundingOptions?.otherProgramName,
      selfElectedStateFundingProgram?.fundingOptions?.stateProgramName,
      selfElectedStateFundingProgram?.fundingOptions?.stateDebitCard,
    ].some(option => Boolean(option))
  ) {
    return true;
  }
  return false;
}

export const FUNDING_OPTION_KEYS = {
  stateProgramName: "stateProgramName" as const,
  otherProgramName: "otherProgramName" as const,
  stateDebitCard: "stateDebitCard" as const,
  statePortal: "statePortal" as const,
  reimbursement: "reimbursement" as const,
  charter: "charter" as const,
  selfPay: "selfPay" as const,
} as const;

export type FundingOptionKey = keyof typeof FUNDING_OPTION_KEYS;
